const PrayStudioLogo = ({ className = '' }: { className?: string }) => {
  return (
    <svg
      width="138"
      height="18"
      viewBox="0 0 138 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      {/* PRAY letters - use currentColor for theme awareness */}
      <path
        d="M10.4888 2.77107C9.43668 1.82917 7.93964 1.32977 6.15982 1.32977H0.00390625V17.0881H2.81228V12.0499H5.84929C7.5903 12.0499 9.1553 11.5643 10.2573 10.6807C11.4591 9.71661 12.0953 8.3225 12.0953 6.63431C12.0953 5.04876 11.5395 3.71296 10.4888 2.77107ZM9.24123 6.70089C9.24123 8.39047 7.94382 9.48222 5.93667 9.48222H2.81086V3.92098H5.93667C8.03808 3.92098 9.24259 4.93501 9.24259 6.70089H9.24123Z"
        fill="currentColor"
      />
      <path
        d="M25.4051 11.1371C27.7754 10.456 29.0798 8.75536 29.0798 6.34305C29.0798 3.25103 26.855 1.32977 23.2746 1.32977H16.3175V17.0881H19.1272V11.6254H22.4776L26.2784 17.0715L26.2895 17.0881H29.6093L29.5622 17.0229L25.4051 11.1371ZM19.1272 3.92375H23.0529C25.0988 3.92375 26.2257 4.83934 26.2257 6.50256C26.2257 8.08256 24.9893 9.10352 23.075 9.10352H19.1272V3.92375Z"
        fill="currentColor"
      />
      <path
        d="M41.9572 1.27161L41.9474 1.24662H39.3706L39.3595 1.27161L32.5466 16.9467L32.5216 17.005H35.3993L35.4104 16.98L36.9919 13.2485H44.2582L45.819 16.98L45.8286 17.005H48.7964L48.7701 16.9467L41.9572 1.27161ZM43.2283 10.7419H38.0233L40.614 4.66322L43.2283 10.7419Z"
        fill="currentColor"
      />
      <path
        d="M60.7617 1.33127L60.7506 1.35069L56.3717 8.23665L52.04 1.35069L52.0276 1.33127H48.6966L54.9274 10.8792V17.0896H57.7732V10.8126L63.9623 1.39508L64.0039 1.33127H60.7617Z"
        fill="currentColor"
      />
      {/* Studio letters - keep gold gradient */}
      <path
        d="M69.2188 5.2305C69.2188 3.7772 70.5359 2.64181 72.6023 2.64181C74.2372 2.64181 75.7132 3.16409 77.1892 4.36761L78.2338 2.98243C76.6215 1.68808 74.9639 1.02956 72.6477 1.02956C69.6275 1.02956 67.4249 2.84618 67.4249 5.38946C67.4249 8.02356 69.1053 9.20437 72.7612 9.99914C76.0993 10.7031 76.894 11.5433 76.894 13.042C76.894 14.6542 75.4862 15.7669 73.3516 15.7669C71.149 15.7669 69.5594 15.0176 67.9017 13.5189L66.7891 14.8359C68.6965 16.539 70.7629 17.3792 73.2835 17.3792C76.4399 17.3792 78.7107 15.608 78.7107 12.8603C78.7107 10.4079 77.0757 9.11354 73.5333 8.34147C70.0363 7.59211 69.2188 6.75193 69.2188 5.2305Z"
        fill="url(#prayStudioLogo_paint0)"
      />
      <path
        d="M84.3142 6.9563H88.0383V5.41216H84.3142V1.86975H82.5657V5.41216H80.9307V6.9563H82.5657V14.0411C82.5657 16.4255 83.9963 17.3565 85.881 17.3565C86.7212 17.3565 87.3797 17.1748 87.9928 16.8569V15.3582C87.3797 15.6534 86.8802 15.7669 86.2898 15.7669C85.1089 15.7669 84.3142 15.2446 84.3142 13.8141V6.9563Z"
        fill="url(#prayStudioLogo_paint1)"
      />
      <path
        d="M99.467 12.1337C99.467 14.3363 97.9456 15.8123 95.9473 15.8123C93.8809 15.8123 92.7001 14.4499 92.7001 12.2699V5.41216H90.9516V12.7014C90.9516 15.4944 92.6093 17.4019 95.4477 17.4019C97.4687 17.4019 98.6722 16.38 99.467 15.1084V17.1521H101.193V5.41216H99.467V12.1337Z"
        fill="url(#prayStudioLogo_paint2)"
      />
      <path
        d="M116.298 17.1521V0.575401H114.55V7.66024C113.641 6.34319 112.234 5.16238 110.054 5.16238C107.238 5.16238 104.445 7.43316 104.445 11.2935C104.445 15.1765 107.238 17.4019 110.054 17.4019C112.211 17.4019 113.596 16.1984 114.55 14.7905V17.1521H116.298ZM114.618 11.2708C114.618 14.0184 112.552 15.8351 110.372 15.8351C108.146 15.8351 106.239 14.0638 106.239 11.2708C106.239 8.4096 108.101 6.72922 110.372 6.72922C112.552 6.72922 114.618 8.54584 114.618 11.2708Z"
        fill="url(#prayStudioLogo_paint3)"
      />
      <path
        d="M122.249 2.84618V0.916018H120.251V2.84618H122.249ZM122.113 17.1521V5.41216H120.364V17.1521H122.113Z"
        fill="url(#prayStudioLogo_paint4)"
      />
      <path
        d="M137.684 11.2708C137.684 7.93273 135.095 5.16238 131.575 5.16238C128.033 5.16238 125.444 7.97815 125.444 11.3162C125.444 14.6542 128.01 17.4246 131.53 17.4246C135.072 17.4246 137.684 14.6088 137.684 11.2708ZM135.89 11.3162C135.89 13.8368 134.118 15.8578 131.575 15.8578C129.1 15.8578 127.238 13.8141 127.238 11.2708C127.238 8.72751 128.986 6.70651 131.53 6.70651C134.005 6.70651 135.89 8.75021 135.89 11.3162Z"
        fill="url(#prayStudioLogo_paint5)"
      />
      <defs>
        <linearGradient
          id="prayStudioLogo_paint0"
          x1="100.571"
          y1="-1.39699"
          x2="100.553"
          y2="28.804"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0625" stopColor="#FFDC84" />
          <stop offset="0.307292" stopColor="#E3AF4A" />
          <stop offset="0.911458" stopColor="#6A562F" />
        </linearGradient>
        <linearGradient
          id="prayStudioLogo_paint1"
          x1="100.571"
          y1="-1.39699"
          x2="100.553"
          y2="28.804"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0625" stopColor="#FFDC84" />
          <stop offset="0.307292" stopColor="#E3AF4A" />
          <stop offset="0.911458" stopColor="#6A562F" />
        </linearGradient>
        <linearGradient
          id="prayStudioLogo_paint2"
          x1="100.571"
          y1="-1.39699"
          x2="100.553"
          y2="28.804"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0625" stopColor="#FFDC84" />
          <stop offset="0.307292" stopColor="#E3AF4A" />
          <stop offset="0.911458" stopColor="#6A562F" />
        </linearGradient>
        <linearGradient
          id="prayStudioLogo_paint3"
          x1="100.571"
          y1="-1.39699"
          x2="100.553"
          y2="28.804"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0625" stopColor="#FFDC84" />
          <stop offset="0.307292" stopColor="#E3AF4A" />
          <stop offset="0.911458" stopColor="#6A562F" />
        </linearGradient>
        <linearGradient
          id="prayStudioLogo_paint4"
          x1="100.571"
          y1="-1.39699"
          x2="100.553"
          y2="28.804"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0625" stopColor="#FFDC84" />
          <stop offset="0.307292" stopColor="#E3AF4A" />
          <stop offset="0.911458" stopColor="#6A562F" />
        </linearGradient>
        <linearGradient
          id="prayStudioLogo_paint5"
          x1="100.571"
          y1="-1.39699"
          x2="100.553"
          y2="28.804"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0625" stopColor="#FFDC84" />
          <stop offset="0.307292" stopColor="#E3AF4A" />
          <stop offset="0.911458" stopColor="#6A562F" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default PrayStudioLogo;
